/*
 * Copyright (c) 2018-Present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
import { connect, useDispatch } from 'react-redux';
import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import { loginRequest } from './components/utils/EntraUtils/AuthConfig';
import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { incrementValue } from './redux/actions/example/exampleActions';
import { setCurrentUserId, setIsUserLoggedIn, setNotificationData } from './redux/actions/uiActions';
import { getCurrentRegionAPIConfigs } from './components/utils/APIsUtils/httpsUtils';
import config from './config';
import { autoAssignSegment, fetchSegmentList, setIsSegmentAssigned } from './redux/actions/segment/segmentActions';
import { parseJwt } from './components/utils/commonUtil';
import { setOktaUserInfo } from './redux/actions/commonDataActions';
import { constants } from './constants';

const currentRegionAPIConfigs = getCurrentRegionAPIConfigs();

const Home = (props) => {
  const { setCurrentUserId, setIsUserLoggedIn } = props;
  const history = useHistory();
  const { instance, accounts, inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();

  const dispatch = useDispatch();

  // useEffect(() => {
  //   if (!isAuthenticated && inProgress === InteractionStatus.None) {
  //     console.log("DEBUG Home /login")
  //     history.push('/login');
  //   }
  // }, [isAuthenticated, inProgress]); // Update if authState changes
  // const login = async () => {
  //   history.push("/login");
  // };

  // if (!authState) {
  //   return <div>Loading...</div>;
  // }

  return (
    <div
      style={{
        margin: '0 auto',
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', width: "100%" }}>
        <span>Loading...</span>
      </div>

      {/* <Header as="h1">PKCE Flow w/ Custom Login Page</Header> */}

      {/* {authState.isAuthenticated && !userInfo && (
          <div>Loading user information...</div>
        )} */}

      {/* {authState.isAuthenticated && userInfo && (
          <div>
            <p id="welcome">
              Welcome, &nbsp;
              {userInfo.name}!
            </p>
          </div>
        )} */}

      {/* {!authState.isAuthenticated && (
          <div>
            <Button id="login-button" primary onClick={login}>
              Login
            </Button>
          </div>
        )} */}
    </div>
  );
};

const mapStateToProps = (state, ownProps) => ({
  state: state,
});

const mapDispatchToProps = (dispatch) => ({
  incrementValue: (options) => dispatch(incrementValue(options)),
  setCurrentUserId: (options) => dispatch(setCurrentUserId(options)),
  setIsUserLoggedIn: (options) => dispatch(setIsUserLoggedIn(options)),
});

export default React.memo(connect(mapStateToProps, mapDispatchToProps)(Home));
